
export default {
  name: 'BaseProfileAuthorHeader',
  props: {
    author: {
      type: Object,
      required: true,
    },
    statistics: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      streamsVisibleCount: 14,
      filterMenu: [],
      isShowAllMenu: false,
    }
  },
  computed: {
    registerFromProfile() {
      if (
        this.author?.registerFrom?.type === 'WELCOME' &&
        this.author.registerFrom.owner
      ) {
        return this.author.registerFrom.owner
      }
      return null
    },
    registerString() {
      if (
        this.author?.registerFrom?.type === 'WELCOME' &&
        this.author.registerFrom.owner
      ) {
        return `Зарегистрирован ${this.$dayjs(this.author.createdAt).format(
          'DD MMMM YYYY'
        )} по приглашению от `
      } else {
        return `Зарегистрирован ${this.$dayjs(this.author.createdAt).format(
          'DD MMMM YYYY'
        )}`
      }
    },
    isModerator() {
      return (
        this.$auth.loggedIn &&
        !!this.$auth?.user?.roles?.some((role) =>
          ['ADMIN', 'MODERATOR', 'ACCOUNTER'].includes(role)
        )
      )
    },
    userName() {
      if (this.author.type === 'COMPANY') {
        return this.author.profile?.title
          ? this.author.profile?.title
          : this.author.username
      } else {
        return this.author.profile?.firstName && this.author.profile?.lastName
          ? `${this.author.profile.firstName} ${this.author.profile.lastName}`
          : this.author.username
      }
    },
    auditorium() {
      if (this.statistics.auditorium < 100) {
        return 'менее 100'
      } else {
        return this.statistics.auditorium
      }
    },
    impressions() {
      return this.statistics?.impression
    },
    streams() {
      const filteredStreams = this.statistics?.forStreams.filter(
        (stream) => !!stream._id
      )
      return filteredStreams.slice(0, this.streamsVisibleCount)
    },
    authorName() {
      return this.author?.profile?.firstName && this.author?.profile?.lastName
        ? `${this.author?.profile?.firstName} ${this.author?.profile?.lastName}`
        : this.author.username
    },
    telegramBroadcast() {
      return this.author?.actions?.broadcast?.telegram?.channels
    },
    userAvatar() {
      if (!this.userLogo) {
        return this.userName[0]
      }
      return null
    },
    userLogo() {
      return this.author.profile?.avatar
    },
  },
  watch: {
    '$route.path'() {
      this.isShowAllMenu = false
    },
  },
  mounted() {
    this.$header.setVisibleAdditionalMenu(false)
    this.$header.setAdditionalMenu(null)
    this.filterMenu.push({
      id: 1,
      title: 'Обзор',
      path: `/${this.author.username}`,
      sub: () => null,
    })
    if (this.statistics.articlesCount + this.statistics.telegramCount > 0) {
      this.filterMenu.push({
        id: 2,
        title: 'Блог',
        path: `/${this.author.username}/materials`,
        sub: () =>
          this.statistics.articlesCount + this.statistics.telegramCount,
      })
    }
    // if (this.statistics.telegramCount > 0) {
    //   this.filterMenu.push({
    //     id: 3,
    //     title: 'Telegram',
    //     path: `/${this.author.username}/telegram`,
    //     sub: this.statistics.telegramCount,
    //   })
    // }
    if (this.statistics.productsCount > 0) {
      this.filterMenu.push({
        id: 4,
        title: 'Акции',
        path: `/${this.author.username}/offers`,
        sub: () => this.statistics.productsCount,
      })
    }
    if (this.statistics.goodsCount > 0) {
      this.filterMenu.push({
        id: 5,
        title: 'Продукты',
        path: `/${this.author.username}/goods`,
        sub: () => this.statistics.goodsCount,
      })
    }
    if (this.statistics.vacancysCount > 0) {
      this.filterMenu.push({
        id: 6,
        title: 'Вакансии',
        path: `/${this.author.username}/vacancys`,
        sub: () => this.statistics.vacancysCount,
      })
    }
    if (this.statistics.eventsCount > 0) {
      this.filterMenu.push({
        id: 7,
        title: 'События',
        path: `/${this.author.username}/events`,
        sub: () => this.statistics.eventsCount,
      })
    }
    if (this.statistics.subscribersCount > 0) {
      this.filterMenu.push({
        id: 8,
        title: 'Подписчики',
        path: `/${this.author.username}/subscribers`,
        sub: () => this.statistics.subscribersCount,
      })
    }
    this.filterMenu.push({
      id: 9,
      title: 'Подписка',
      path: `/${this.author.username}/subscriptions`,
      sub: () => this.statistics.subscriptionsCount,
    })
    if (this.statistics.skillsCount > 0) {
      this.filterMenu.push({
        id: 10,
        title: 'Навыки',
        path: `/${this.author.username}/skills`,
        sub: () => this.statistics.skillsCount,
      })
    }
    this.$header.setAdditionalMenu({
      logo: this.userLogo,
      avatar: this.userAvatar,
      title: null,
      menu: this.filterMenu,
    })
  },
  beforeDestroy() {
    this.$header.setAdditionalMenu(null)
  },
  methods: {
    inView({ isInView }) {
      if (isInView) {
        this.setShow()
      }
    },
    setShow() {
      this.$axios.$post('/activity/view/author', {
        username: this.author.username,
      })
    },
    handleScroll(_event, el) {
      if (el) {
        const { bottom } = el.getBoundingClientRect()
        if (bottom < 0) {
          this.$header.setVisibleAdditionalMenu(true)
        } else {
          this.$header.setVisibleAdditionalMenu(false)
        }
      }
    },
    update() {
      this.$eventBus.$emit('Accounting-update')
      this.$emit('update')
    },
    formatText(value, titles) {
      const num = isNaN(value)
        ? Number(
            value
              .replace('−', '-')
              .replace(/^(-)|[.,](?=[^.,]*[.,](?!$))|[,.]+$|[^0-9.,-]+/g, '$1')
          )
        : value

      const number = Math.abs(num)
      return `${
        titles[
          number % 100 > 4 && number % 100 < 20
            ? 2
            : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? number % 10 : 5]
        ]
      }`
    },
    openRecommendationPopUp() {
      this.$refs.createRecommendation.open()
    },
  },
}
